import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const ReceiptNavReportListComponent = (props) => {

  const {t} = props;
  const [receiptNavReports, setReceiptNavReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/nav-report?search[receipt][operator]==&search[receipt][value]=' + props.receiptId + '&' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setReceiptNavReports(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
  //                 tooltip={t('edit')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if(entity === 'nav-report') {
  //                     history.push('/finance/receipt/read/' + rowData.id + '/nav-report/update/' + rowData.id)
  //                   }
  //                 }}/>
  //       }
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-trash" className="p-button-danger"
  //                 tooltip={t('delete')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if (window.confirm('A törlés megerősítésére van szükség!')) {
  //                     setLoading(true);
  //                     apiCall('delete', '/api/v2/nav-report/' + rowData.id)
  //                       .then(response => {
  //                         window.App.toastShow('success', 'Sikeres törlés!');
  //                         window.App.setState({rerenderReceiptNavReportList: Math.random()})
  //                       })
  //                       .catch(error => {
  //                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //                       })
  //                       .finally(() => {
  //                         setLoading(false);
  //                       })
  //                   }
  //                 }}
  //         />
  //       }
  //     </React.Fragment>
  //   );
  // }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderReceiptNavReportList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={receiptNavReports} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
         <Column field="last_status" header={t('columnStatus2')} sortable
            body={(rowData) => {
              return (
                <>
                  {rowData.last_status === 'PROCESSING' &&
                  <>
                            <span className={"text-warning"}><i
                              className={"pi pi-exclamation-circle"}></i> Feldolgozás folyamatban</span>
                  </>
                  }
                  {rowData.last_status === 'RECEIVED' &&
                  <>
                            <span className={"text-warning"}><i
                              className={"pi pi-exclamation-circle"}></i> Információk átadva</span>
                  </>
                  }
                  {rowData.last_status === 'SAVED' &&
                  <>
                    <span className={"text-success"}><i className={"pi pi-check"}></i> Információk rögzítve</span>
                  </>
                  }
                  {rowData.last_status === 'ABORTED' &&
                  <>
                    <span className={"text-danger"}><i
                      className={"pi pi-times"}></i> Megszakítva</span>
                  </>
                  }
                  {rowData.last_status === 'DONE' &&
                  <>
                            <span className={"text-success"}><i
                              className={"pi pi-check"}></i> Sikeres</span>
                  </>
                  }
                  {rowData.last_status === null &&
                  <>
                    <span><i className={"pi pi-times"}></i> Nincs adat</span>
                  </>
                  }
                  {rowData.last_status_message !== null &&
                  <>
                    <br/>
                    <small style={{
                      fontSize: '10px',
                      wordWrap: 'break-word',
                      display: 'block',
                      maxWidth: '220px'
                    }}>{rowData.last_status_message}</small>
                  </>
                  }
                </>
              )
            }}
    />
    <Column field="type" header={t('columnType')} sortable
            body={(rowData) => {
              return (
                <>
                  {rowData.type === 'CREATE' &&
                  <>
                    Kiállított számla
                  </>
                  }
                  {rowData.type === 'STORNO' &&
                  <>
                    {t('stornoInvoice')}
                  </>
                  }
                  {rowData.type === 'MODIFY' &&
                  <>
                    Módosító számla
                  </>
                  }
                  {rowData.type === 'ANNULMENT' &&
                  <>
                    Technikai érvénytelenítés
                  </>
                  }
                </>
              )
            }}></Column>
    <Column field="transaction_id" header={t('columnIdentifier')}
            ></Column>
    <Column field="report_date" header={t('columnDateAndTime')} className={"p-text-nowrap"}
            body={(rowData) => {
              return (
                <>{window.App.formatDateValue(rowData.reportDate)}</>
              )
            }}></Column>
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ReceiptNavReportListComponent);
